module.exports = __webpack_public_path__ + "img/AmericanExpress(PersonalSavings).1cd5752e.svg";